<!--
 * @Author: chenmengnan
 * @Date: 2024-10-17 17:08:12
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-27 16:01:47
 * @Description: 日志管理
 * @FilePath: \web\src\components\DataManagement\logManagement\logManagement.vue
-->
<template>
  <div class="log-management-wrap">
    <div class="search-container">
      <div class="search">
        <!-- S 用户名 -->
        <div class="search-item">
          <div class="search-item-text">用户名：</div>
          <a-input class="user-name-input" v-model:value="requestParams.username" />
        </div>
        <!-- E 用户名 -->
        <div class="search-item">
          <div class="search-item-text">用户单位：</div>
          <a-input class="user-name-input" v-model:value="requestParams.orgName" />
        </div>
        <div class="search-item">
          <div class="search-item-text">操作类型：</div>
          <a-input class="user-name-input" v-model:value="requestParams.operateType" />
        </div>
        <div class="search-item" style="width: 3.2rem">
          <div class="search-item-text">操作时间：</div>
          <a-range-picker v-model:value="requestParams.timeRange" />
        </div>
        <!-- 组织机构 -->
        <div class="btn-wrapper">
          <div class="reset-btn btn-item" @click="resetSearch">重置</div>
          <div class="search-btn btn-item" @click="submitSearch()">查询</div>
        </div>
      </div>
    </div>
    <a-table rowKey="id" class="management-table" :dataSource="logPages" :loading="userPagesLoading" :columns="columns"
      @change="changePage" :scroll="{ y: '90%' }" :pagination="paginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>
      <!-- 单位类型 -->
      <template #orgType="{ record }">
        {{ record.sysOrg?.orgType }}
      </template>
      <!-- 单位名称 -->
      <template #name="{ record }">
        {{ record.sysOrg?.name }}
      </template>
      <!-- 行业类型 -->
      <template #tradeType="{ record }">
        {{ record.sysOrg?.tradeType }}
      </template>
      <template #integral="{ record }">
        {{ record.integral || '-' }}
      </template>

      <template #sysRoleList="{ record }">
        {{ userRole(record) }}
      </template>
    </a-table>


  </div>
</template>

<script setup>
import { ref, reactive, computed, onBeforeMount, } from 'vue';
import dayjs from 'dayjs';
import { getLogLsitPageApi } from '@/api/dataManagement/logManagement.js';

import tableConfig from './tableConfig.js';

const columns = tableConfig;
const totalCount = ref(0)
const userPagesLoading = ref(false);
const logPages = ref([])
const requestParams = reactive({
  username: '',
  orgName: '',
  operateType: '',
  timeRange: null,
  page: 1,
  size: 10
})
const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.size,
  current: requestParams.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['8', '10', '20', '30', '40', '50',],
}));


const userRole = (record) => {
  const ll = [];

  if (record.sysRoleList) {
    record.sysRoleList.forEach(item => ll.push(item.description));
  }

  return ll.toString();
};

/**
 * @description 检索查询事件
 */
const submitSearch = () => {

  requestParams.page = 1;
  requestParams.size = 10
  getLogList();
};

/**
 * @description 检索重置事件
 */
const resetSearch = () => {
  requestParams.username = '';
  requestParams.timeRange = null;
  requestParams.orgName = '';
  requestParams.operateType = '';
  requestParams.page = 1;
  requestParams.size = 10
  getLogList();
};



/* 获取日志数据 */
const getLogList = () => {
  const params = JSON.parse(JSON.stringify(requestParams))
  userPagesLoading.value = true;
  params.startDate = params.timeRange ? `${dayjs(params.timeRange[0]).format('YYYY-MM-DD')} 00:00:00` : null;
  params.endDate = params.timeRange ? `${dayjs(params.timeRange[1]).format('YYYY-MM-DD')} 23:59:59` : null;
  delete params.timeRange
  getLogLsitPageApi(params).then(res => {
    userPagesLoading.value = false
    logPages.value = res.data.list
    totalCount.value = res.data.totalCount
  });
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  requestParams.page = page.current;
  requestParams.size = page.pageSize
  getLogList()
};



onBeforeMount(() => {
  getLogList();
});

</script>

<style lang="scss">
.log-management-wrap {
  width: 100%;
  height: 100%;
  background: rgba(179, 150, 92, 0.05);

  /* 检索条件 */
  .search-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: .1rem;
    height: 0.5rem;
    margin-bottom: 0.1rem;

    .search {
      display: flex;

      .search-item {
        width: 2.2rem;
        height: 0.34rem;
        margin-right: 0.05rem;
        display: flex;

        .search-item-text {
          color: #fff;
          width: 1.1rem;
          text-align: right;
          height: 0.34rem;
          line-height: 0.34rem;
        }

        .ant-calendar-picker-input {
          height: .34rem;
        }
      }

      /* 重置、查询操作 */
      .btn-wrapper {
        height: 0.32rem;
        line-height: 0.32rem;
        margin-left: 0.2rem;
        color: #ffffff;
        display: flex;
        padding: 0;

        .btn-item {
          width: 0.9rem;
          text-align: center;
          cursor: pointer;

          &:active {
            opacity: 0.8;
          }
        }

        .reset-btn {
          // background-color: #535962;
          background-image: url(~@/static/images/dataManagement/reset_btn.png);
          background-size: 100% 100%;
        }

        .search-btn {
          margin-left: 0.05rem;
          // background-color: #efb227;
          background-image: url(~@/static/images/dataManagement/submit_btn.png);
          background-size: 100% 100%;
        }
      }

      /* 输入框 */
      .ant-input {
        color: white;
        background-color: rgba(91, 76, 39, 0.4);
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        border: transparent;
      }

      .ant-input-suffix {
        width: 0.12rem;
        height: 0.12rem;
        margin-top: .02rem;
      }

      /** 下拉框 */
      .ant-select {
        width: 100%;
        height: 100%;

        .ant-select-selector {
          height: 100%;
        }

        .ant-select-arrow {
          color: #fff;
        }

        .ant-select-selection-item {
          line-height: .34rem;
        }

        // 背景
        &:not(.ant-select-customize-input) .ant-select-selector {
          background-color: rgba(91, 76, 39, 0.4);
          border: none;
          color: #fff;
        }

        /* 描述 */
        .ant-select-selection-placeholder {
          line-height: .34rem;
          color: #fff;
        }
      }
    }

    /* 增删改导按钮 */
    .crud-wrapper {
      display: flex;
      height: 0.51rem;
      padding: 0.13rem 0.1rem;

      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        line-height: .25rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 表格样式 */
  .management-table {
    height: calc(100% - 0.5rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
        margin-bottom: 0 !important;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #dccdab;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }

}
</style>
